import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import ActionText from '../../core/ActionText';
import GS from '../../grafsync/grafsync';
import { globalStyles as styles } from '../style/gstheme';
import UserContainer from './UserContainer';
import UserStructure from './UserStructure';

class UsersManager extends Component {

  constructor(props) {
    super(props);
    this.state = {
      updateAt: null,
      blockedChanges: {},
      altered: false,
      selectedUser: null,
    };
  }

  selectUser = (id) => this.setState({ selectedUser: id, altered: false });

  onBlockUser = (user) => {
    let updatedBlockedChanges = Object.assign({}, this.state.blockedChanges);
    updatedBlockedChanges[user] = "blocked";
    this.setState({ blockedChanges: updatedBlockedChanges, updateAt: Date.now() });
    GS.blockUser(user);
  };

  onUnblockUser = (user) => {
    let updatedBlockedChanges = Object.assign({}, this.state.blockedChanges);
    updatedBlockedChanges[user] = "unblocked";
    this.setState({ blockedChanges: updatedBlockedChanges, updateAt: Date.now() });
    GS.unblockUser(user);
  };

  onUpdate = () => {
    if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ altered: false });
  };

  tryAgain = () => this.setState({ selectedUser: null });

  render() {

    const { classes, user } = this.props;
    const { selectedUser, updateAt, deletedUsers, altered, blockedChanges } = this.state;

    return (
      <div>
        <UserStructure
          onUpdate={this.onUpdate}
          deletedUsers={deletedUsers}
          refreshAt={updateAt}
          altered={altered}
          displayUser={this.selectUser}
          selectedUser={selectedUser}
          blockedChanges={blockedChanges}
          onSelectUser={this.selectUser} />
        <div className={classes.dashboardPanel}>
          {selectedUser ?
            <UserContainer
              key={selectedUser}
              blockedChanges={blockedChanges}
              managingUser={user}
              user={selectedUser}
              onUnblockUser={this.onUnblockUser}
              onBlockUser={this.onBlockUser} />
            :
            <ActionText offset="180px">Select a user to view their detail</ActionText>}
        </div>
      </div>
    );
  }
}

UsersManager.propTypes = {
  classes: PropTypes.object,
  user: PropTypes.object
};

export default withStyles(styles)(UsersManager);